import { client } from "../client";
import { SavedFile } from "../types/files.types";

export const createFile = async ({
	file,
	fileName,
}: {
	file: File;
	fileName: string | undefined;
}) => {
	const response = await client.postForm<SavedFile>(`files/`, {
		file,
		fileName: fileName,
	});
	return response.data;
};

export const fetchFileContent = async (id: number | string | undefined) => {
	if (id == undefined) {
		return null;
	}
	const response = await client.get(`files/download/${id}`, {
		responseType: "arraybuffer",
	});
	return response.data;
};
